import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import {FaUniversity, FaArrowRight} from "react-icons/fa";
import {useTranslation} from "react-i18next";
import styles from "./Directions.module.css";
import {testUrl} from "../BaseData";

const Direction = ({ titleOverride, endpoint, filterLevel }) => {
    const {t, i18n} = useTranslation();
    const [directions, setDirection] = useState([]);

    useEffect(() => {
        axios
            .get(
                testUrl + (endpoint || "/api/directions/")
            )
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : response.data?.results || [];
                // Temporarily removed level filtering until database migration is applied
                // const filtered = filterLevel ? data.filter(d => (d.level === filterLevel || d.level?.toLowerCase() === filterLevel)) : data;
                setDirection(data);
            })
            .catch((error) =>
                console.error("Error fetching kafedra data: ", error)
            );

        // axios
        //     .get(
        //         BaseURL + "api/kafedra/kafedra-cards/"
        //     )
        //     .then((response) => {
        //         setDepartments(response.data);
        //     })
        //     .catch((error) =>
        //         console.error("Error fetching departments data: ", error)
        //     );
    }, [i18n.language, endpoint, filterLevel]);

    const getDirectionName = (direction) => {
        const name = direction[`name_${i18n.language}`];
        return name || direction.name_uz || t("no_name_available");
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>
                <div className={styles.section}>
                    <h3 className={styles.title}>
                        {titleOverride || t("directions")}
                    </h3>
                    <div className={styles.facultyList}>
                        {directions.length > 0 ? (
                            directions.filter(Boolean).map((direction) => (
                                <Link
                                    key={direction.id || direction.short_name}
                                    to={`/directions/${direction?.short_name}`}
                                    className={styles.facultyCard}
                                >
                                    <img
                                        src={direction?.image || "/default-image.jpg"}
                                        alt={getDirectionName(direction) || t("no_name_available")}
                                        className={styles.facultyImage}
                                    />
                                    <div className={styles.facultyInfo}>
                                        <h3>{getDirectionName(direction)}</h3>
                                        <FaUniversity className={styles.icon}/>
                                    </div>
                                    <div className={styles.viewMore}>
                                        <span>{t("see_more")}</span>
                                        <FaArrowRight/>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div>{t("no_direction_found")}</div>
                        )}
                    </div>
                </div>

                {/* Departments Section */}
                {/* <div className={styles.section}>
                    <h3 className={styles.title}>{t("departments")}</h3>
                    <div className={styles.facultyList}>
                        {departments.length > 0 ? (
                            departments.filter(Boolean).map((department) => (
                                <Link
                                    key={department.id}
                                    to={`/faculty-kafedra/${department.slug}`}
                                    className={styles.facultyCard}
                                >
                                    <img
                                        src={department.faculty?.image || "/default-image.jpg"}
                                        alt={
                                            getDepartmentName(department) || t("no_name_available")
                                        }
                                        className={styles.facultyImage}
                                    />
                                    <div className={styles.facultyInfo}>
                                        <h3>{getDepartmentName(department)}</h3>
                                        <FaUniversity className={styles.icon}/>
                                    </div>
                                    <div className={styles.viewMore}>
                                        <span>{t("see_more")}</span>
                                        <FaArrowRight/>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div>{t("no_departments_found")}</div>
                        )}
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Direction;
